var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 2.05103L12.8937 3.83287L21.2765 20.5438L22.0031 21.9922H20.3827H3.61699H1.99658L2.72315 20.5438L11.106 3.83287L11.9998 2.05103ZM5.2374 19.9922H18.7623L11.9998 6.51148L5.2374 19.9922ZM10.9773 11.0001H12.9773V16.0001H10.9773V11.0001ZM12.9999 17H10.9999V19H12.9999V17Z",
    fill: "#E56C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.90bbab10bb5584964ce3677d2f5b9afa.svg";
export { ForwardRef as ReactComponent };